import React, {useRef} from 'react'
import styles from './Map.module.css'
import Shared from '../services/Shared';
import Button from '@material-ui/core/Button';
import Pets from '@material-ui/icons/Pets';
import Navbar from './Navbar'

export default function Map() {

    const anchor = useRef(); //similar to document.getElementById()

    function onDownload(e) {
        anchor.current.click();
    }

    return (
        <>
            <Navbar></Navbar>
            <div className={styles.contain}>
                <h1>Campus Map &nbsp; <Pets/> </h1>
                <div className={styles.downloadButton}>
                    <Button size="large" onClick={onDownload}>Download
                    </Button>
                    <a ref={anchor} href={Shared.assets + '/map.png'} download hidden={true}>Download</a>
                </div>
                <div><img className={styles.map} alt='campus map' src={Shared.assets + '/map.png'} /></div>
            </div>
        </>
    )
}
